import { Injectable } from '@angular/core';
import { RequestOptions, Headers, Http } from '@angular/http';
import { SpinnerService } from 'app/shared/spinner.service';
import { ResponseUtilService } from 'app/shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EventCollisionService {

  private eventCollisionURL = 'https://grouppay-matching-api.qa.onyxcentersource.com/rest/private/matching';
  /* private eventCollisionURL = 'https://pe2api.dev.onyxcentersource.com/api/matching_service'; */


  constructor(private spinnerService: SpinnerService, private http: Http, private responseUtilService: ResponseUtilService) { }

  getEventCollisionPropertyMatches(event_info: any): Observable<any> {
    let headers = new Headers();
    const token1 = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9';
    const token2 = '.eyJjaWQiOiJBUzUwMCIsImlhdCI6MTY1NDg0MzA3NiwiZXhwIjoxNjU0ODQ0ODc2fQ';
    const token3 = '.1ncYutbEH2J3a72h8Xfcu6wuc2raPZ22BBG9-c6aTHE4TNCPLERrWlv06fOwKoa-a98nB2eJXQdl94LeFULJ7A';
    headers.append('Authorization', 'Bearer ' + (token1 + token2 + token3));
    headers.append('Content-Type', 'application/json');
    const options = new RequestOptions({ headers: headers }); // Create a request option
    this.spinnerService.start();
    return this.http.put(`${this.eventCollisionURL}`, JSON.stringify({event_info}), options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share()
      .finally(() => {
        this.spinnerService.finish();
      });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/event-collision/event-collision.service.ts